export default "__VITE_ASSET__9SUaBhla__"